import { Truck, Plane, Ship } from "lucide-react";
import { Reveal } from "./Reveal";

const modes = [
  { icon: Truck, t: "Ground Expedite", d: "Dedicated cargo-van transportation for urgent and time-sensitive freight.", core: true },
  { icon: Plane, t: "Air Freight Coordination", d: "Support for shipments that require faster airport-to-airport or airport-to-door movement." },
  { icon: Ship, t: "Ocean Shipping Coordination", d: "Flexible coordination for international cargo moving through major ports and inland destinations." },
];

export const LogisticsStrip = () => (
  <section className="bg-oyf-charcoal text-white" data-testid="logistics-strip">
    <div className="container-oyf py-16 md:py-20 grid md:grid-cols-3 gap-6">
      {modes.map((m, i) => (
        <Reveal key={m.t} delay={i * 0.1}>
          <div className={`relative h-full rounded-lg p-7 border transition-colors duration-300 ${m.core ? "bg-oyf-yellow text-oyf-black border-oyf-yellow" : "bg-white/[0.03] border-white/10 hover:border-oyf-yellow/50"}`}>
            {m.core && <span className="absolute top-5 right-5 text-[10px] font-bold tracking-widest uppercase bg-oyf-black text-oyf-yellow px-2 py-1 rounded">Core Specialization</span>}
            <m.icon size={38} strokeWidth={2} className={m.core ? "text-oyf-black" : "text-oyf-yellow"} />
            <h3 className={`font-display font-extrabold text-2xl mt-5 ${m.core ? "text-oyf-black" : "text-white"}`}>{m.t}</h3>
            <p className={`mt-2.5 text-[15px] leading-relaxed ${m.core ? "text-oyf-black/75" : "text-white/65"}`}>{m.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
